var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.715 11.653a1.14 1.14 0 01-1.606 0l-4.014-4.1-4.087 4.084a1.164 1.164 0 01-2.007-.852 1.11 1.11 0 01.4-.8l4.014-4.02L.401 1.94A1.137 1.137 0 112.008.333l4.014 4.02 4.014-4.02a1.136 1.136 0 111.606 1.608L7.628 5.96l4.014 4.1a1.15 1.15 0 01.072 1.592h.001z"
  })));
}
export default SvgCancel;